"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProviders = exports.generateUrl = exports.generateEsignUrl = exports.completeFlow = exports.clearUrl = exports.GET_URL = exports.GET_PROVIDERS = exports.GET_ESIGN_URL = exports.COMPLETE_FLOW = exports.CLEAR_URL = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxActions = require("redux-actions");

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var CLEAR_URL = 'CLEAR_POINTSERV_URL';
exports.CLEAR_URL = CLEAR_URL;
var GET_PROVIDERS = 'GET_POINTSERV_PROVIDERS';
exports.GET_PROVIDERS = GET_PROVIDERS;
var GET_URL = 'GET_POINTSERV_URL';
exports.GET_URL = GET_URL;
var GET_ESIGN_URL = 'GET_POINTSERV_ESIGN_URL';
exports.GET_ESIGN_URL = GET_ESIGN_URL;
var COMPLETE_FLOW = 'COMPLETE_POINTSERV_FLOW';
exports.COMPLETE_FLOW = COMPLETE_FLOW;
var CONTEXT = '/pointserv/secure/api/v1';
/**
 * Clear the PointServ URL.  This is used when we are no longer using the PointServ flow so that we don't accidentally use a stale
 * URL if we have to repeat the PointServ flow at a later time.
 */

var clearUrl = (0, _reduxActions.createAction)(CLEAR_URL);
/**
 * Get a list of PointServ-supported payroll or tax providers.
 *
 * @param {Object} params Query params for the PointServ providers endpoint with the keys:
 *   One of tax or payroll is required.
 *   - {Boolean?} tax: Whether or not to get the list of PointServ tax providers.
 *   - {Boolean?} payroll: Whether or not to get the list of PointServ payroll providers.
 */

exports.clearUrl = clearUrl;

var getProviders = function getProviders(params) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_PROVIDERS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/providerList"), {
                params: params
              }, {
                params: params
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Request a PointServ flow URL for the application and income source with the given document types as query parameters.
 *
 * @param {String} applicationUuid
 * @param {Object?} params Query params for the PointServ URL endpoint with the keys:
 *   One of tax or payroll is required.
 *   - {Boolean?} tax: Whether or not to include the tax provider PointServ flow.
 *   - {Boolean?} payroll: Whether or not to include the payroll provider PointServ flow.
 *   - {String?} providerId: The selected PointServ provider ID.
 */


exports.getProviders = getProviders;

var generateUrl = function generateUrl(applicationUuid, params) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxGet)(GET_URL, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/url/").concat(applicationUuid), {
                params: params
              }, {
                params: params
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.generateUrl = generateUrl;

var generateEsignUrl = function generateEsignUrl(applicationUuid, params) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(GET_ESIGN_URL, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/esignUrl/").concat(applicationUuid), {
                params: params
              }, {
                params: params
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/**
 * Mark the PointServ flow as complete.
 * @param {String} orderId The order ID for the PointServ flow.
 */


exports.generateEsignUrl = generateEsignUrl;

var completeFlow = function completeFlow(orderId) {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(COMPLETE_FLOW, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/frontEndFlow/").concat(orderId)));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.completeFlow = completeFlow;